'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = undefined;

var _components = require('@rebass/components');

var _components2 = _interopRequireDefault(_components);

var _styledSystem = require('styled-system');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tooltip = exports.Tooltip = (0, _components2.default)({
  color: 'white',
  bg: 'black'
}, function (props) {
  return {
    display: 'inline-block',
    position: 'relative',
    color: 'inherit',
    backgroundColor: 'transparent',
    '&::before': {
      display: 'none',
      content: '"' + props.text + '"',
      position: 'absolute',
      bottom: '100%',
      left: '50%',
      transform: 'translate(-50%, -4px)',
      whiteSpace: 'nowrap',
      fontSize: (0, _styledSystem.themeGet)('fontSizes.0', '10px')(props),
      paddingTop: '4px',
      paddingBottom: '4px',
      paddingLeft: '8px',
      paddingRight: '8px',
      color: (0, _styledSystem.themeGet)('colors.' + props.color)(props),
      backgroundColor: (0, _styledSystem.themeGet)('colors.' + props.bg)(props),
      borderRadius: (0, _styledSystem.themeGet)('radii.1')(props) + 'px'
    },
    '&::after': {
      display: 'none',
      position: 'absolute',
      bottom: '100%',
      left: '50%',
      transform: 'translate(-50%, 8px)',
      content: '" "',
      borderWidth: '6px',
      borderStyle: 'solid',
      borderColor: 'transparent',
      borderTopColor: (0, _styledSystem.themeGet)('colors.' + props.bg)(props)
    },
    '&:hover': {
      '&::before, &::after': {
        display: 'block'
      }
    }
  };
}, 'space', 'color');

Tooltip.displayName = 'Tooltip';

exports.default = Tooltip;